import React, { useState } from "react";
import { Play } from "lucide-react";
import { API } from "../lib/api";
import { useT } from "../lib/i18n";

// Standalone product video section (shown after the hero when enabled in Admin).
// Clean poster + central Play control; the native video bar only appears after the
// customer taps play. No autoplay. Video is only loaded on demand (preload=none).
export default function ProductVideoSection({ pv }) {
  const { t } = useT();
  const [playing, setPlaying] = useState(false);
  if (!pv?.enabled || !pv?.has_video) return null;
  const v = Number(pv.version || 0);
  const poster = pv.has_poster ? `${API}/media/product-poster?v=${v}` : "/brand/hero.png";

  return (
    <section className="mx-auto max-w-3xl px-4 pt-10" data-testid="product-video-section">
      <div className="relative mx-auto w-full max-w-sm overflow-hidden rounded-[1.3rem] border bg-black shadow-[var(--shadow-soft)]" style={{ aspectRatio: "4 / 5" }}>
        {playing ? (
          <video
            src={`${API}/media/product-video?v=${v}`}
            poster={poster}
            controls
            autoPlay
            playsInline
            preload="none"
            className="h-full w-full object-contain"
            data-testid="product-video-player"
          />
        ) : (
          <button type="button" onClick={() => setPlaying(true)} aria-label={t("play_video")} data-testid="product-video-play" className="group absolute inset-0 h-full w-full">
            <img src={poster} alt="" className="h-full w-full object-cover" loading="lazy" />
            <span className="absolute inset-0 grid place-items-center bg-black/10">
              <span className="grid h-16 w-16 place-items-center rounded-full bg-white/90 shadow-lg transition-transform duration-200 group-hover:scale-105">
                <Play className="h-7 w-7 translate-x-0.5" style={{ color: "hsl(var(--brand-rose))" }} fill="currentColor" />
              </span>
            </span>
          </button>
        )}
      </div>
    </section>
  );
}
